module.exports = __webpack_public_path__ + "assets/bell-filled.5f7ab7ba95b0bf464d1e5b8ce99647a9.svg";